import i18n from "@/plugins/vue-i18n";

import DealershipApplications from "@/views/settings/dealership-applications/index";
import DealershipApplicationsList from "@/views/settings/dealership-applications/index/tabs/ApplicationsTab.vue";
import DealershipApplicationsAnalytics from "@/views/settings/dealership-applications/index/tabs/AnalyticsTab.vue";
import DealershipApplicationsDetails from "@/views/settings/dealership-applications/details";

const dealershipApplications = [
  {
    path: "settings/new-applications",
    redirect: (to) => ({
      name: "DealershipApplications",
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: "settings/new-applications/:id/details",
    redirect: (to) => ({
      name: "DealershipApplicationsDetails",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: "settings/dealership-applications",
    component: DealershipApplications,
    children: [
      {
        path: "/settings/dealership-applications",
        name: "DealershipApplications",
        component: DealershipApplicationsList,
        meta: {
          title: i18n.t("title.dealershipApplications._"),
        },
      },
      {
        path: "analytics",
        name: "DealershipApplicationsAnalytics",
        component: DealershipApplicationsAnalytics,
        meta: {
          title: i18n.t("title.dealershipApplications.analytics"),
          permission: "customer.applications_analytics",
        },
      },
    ],
  },
  {
    path: "settings/dealership-applications/:id/details",
    name: "DealershipApplicationsDetails",
    component: DealershipApplicationsDetails,
    meta: {
      title: i18n.t("title.dealershipApplications.details"),
    },
  },
];

export default dealershipApplications;
